<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@/mixins/shared/formInput.js";
import Color from '@/pages/components/form/input-only/color.vue';

export default {
	mixins: [formInput],
	components: {FormGroup, Color},
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		}
	},
}
</script>

<template>
	<FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
		<template #label v-if="$slots.label">
			<slot name="label" />
		</template>

		<template #label v-if="!$slots.label">
			{{ label }}
		</template>

		<Color
			v-bind="$attrs"
			:form="form"
			:name="name"
			:id="renderedId"
			:model-value="modelValue"
			@update:modelValue="changeModelValueTo"
		>
			<template #addonbefore v-if="$slots.addonbefore"><slot name="addonbefore" /></template>
			<template #addonafter v-if="$slots.addonafter"><slot name="addonafter" /></template>
			<template #descriptionbottom v-if="$slots.descriptionbottom"><slot name="descriptionbottom" /></template>
		</Color>
	</FormGroup>
</template>